import { setResources } from "store/resourcesState";
import { listResources as listRes } from "api";


export const listResources = () => (dispatch, getState) => {
    return listRes().then(data => {
        dispatch(setResources(data));
    });
}